export default __webpack_public_path__ + "static/media/refer.698eb57d.svg";